// extracted by mini-css-extract-plugin
module.exports = {"Warning":"edostMap_Warning__r5p4E","Location":"edostMap_Location__aCtdX"};